import { render } from "./periodoTable.vue?vue&type=template&id=c53c221e&scoped=true"
import script from "./periodoTable.vue?vue&type=script&lang=js"
export * from "./periodoTable.vue?vue&type=script&lang=js"

import "./periodoTable.vue?vue&type=style&index=0&id=c53c221e&lang=css"
import "./periodoTable.vue?vue&type=style&index=1&id=c53c221e&scoped=true&lang=css"
import "./periodoTable.vue?vue&type=style&index=2&id=c53c221e&scoped=true&lang=css"
import "./periodoTable.vue?vue&type=style&index=3&id=c53c221e&lang=scss&scoped=true"
import "./periodoTable.vue?vue&type=style&index=4&id=c53c221e&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c53c221e"]])

export default __exports__